import type { Dispatch, SetStateAction } from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import type { MenuItem as MenuItemType } from '../../../../../../types';
import { useTabsKeyboardNavigation } from '../../../../../helpers';
import { TabsControlItem } from './TabsControlItem';

interface TabsControlProps {
  selectedMenu?: MenuItemType;
  setSelectedMenu?: Dispatch<SetStateAction<MenuItemType | undefined>>;
}

export function TabsControl({
  selectedMenu,
  setSelectedMenu
}: TabsControlProps) {
  const { menus = [], showMenuIcon } = useSettings();
  const [widths, setWidths] = useState<number[]>(Array(menus.length).fill(0));
  const showIcon = menus.some(
    ({ iconMenuType, icon }) =>
      (iconMenuType && iconMenuType !== 'none') || (icon && !iconMenuType)
  );

  const { tabsRef, handleKeyDown } = useTabsKeyboardNavigation(
    menus,
    setSelectedMenu
  );

  return (
    menus.length > 1 && (
      <Component>
        {menus.map((item, index) => (
          <StyledTabsItem
            ref={(el) => (tabsRef.current[index] = el)}
            data={item}
            key={item.id ?? index}
            selectedMenu={selectedMenu}
            showIcon={showIcon && showMenuIcon}
            widths={widths}
            setWidths={setWidths}
            onClick={() => setSelectedMenu?.(item)}
            onKeyDown={(e) => handleKeyDown(e, index, item)}
          />
        ))}
      </Component>
    )
  );
}

const Component = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: -12px 0;
`;

const StyledTabsItem = styled(TabsControlItem)``;
